import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable, take } from 'rxjs';
import { map } from 'rxjs/operators';

import { filterBoolean } from '@recruitee/common';
import {
  RecentNavigationSnapshot,
  RequisitionVisitedSnapshot,
  ResourceKind,
} from '@recruitee/dashboard-types';
import { RequisitionsSelectors } from '@recruitee/requisitions-data';
import type { Requisition } from '@recruitee/requisitions-types';

const mapToRecentNavigationSnapshot = (requisition: Requisition): RequisitionVisitedSnapshot => {
  const { id, title } = requisition;
  return { id, name: title, kind: ResourceKind.Requisition };
};

export const requisitionSnapshotResolver = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<RecentNavigationSnapshot> => {
  const store = inject(Store);

  return store
    .select(RequisitionsSelectors.byId(route.params.id))
    .pipe(filterBoolean, take(1), map(mapToRecentNavigationSnapshot));
};
